import { useEffect, useSyncExternalStore } from 'react';
import { pendingReferral } from '@/lib/pendingReferral';

export default function usePendingReferral() {
  const code = useSyncExternalStore(pendingReferral.subscribe, pendingReferral.snapshot, () => '');
  useEffect(() => { pendingReferral.hydrate(); }, []);
  return code;
}
